import dayjs from 'dayjs';
import SalaryReviewTerm from './SalaryReviewTerm.js';
import User from './User.js';
import GradationalSalary from './GradationalSalary.js';
import Job from './Job.js';
import SalaryReviewAllowance from './SalaryReviewAllowance';

export default class SalaryReview {
  constructor(data) {
    this.id = data?.id;
    this.salaryReviewTermId = data?.salaryReviewTermId;
    this.userId = data?.userId;
    this.jobId = data?.jobId;
    this.currentGradationalSalaryId = data?.currentGradationalSalaryId;
    this.gradationalSalaryId = data?.gradationalSalaryId;
    this.currentSalary = data?.currentSalary ? Number(data.currentSalary) : null;
    this.salary = data?.salary ? Number(data.salary) : 0;
    this.finalEvaluation = data?.finalEvaluation;
    this.payrollRank = data?.payrollRank;
    this.adjustment = data?.adjustment ? Number(data.adjustment) : 0;
    this.createdAt = data?.createdAt ? dayjs(data.createdAt) : null;
    this.updatedAt = data?.updatedAt ? dayjs(data.updatedAt) : null;

    this.salaryReviewTerm = data?.salaryReviewTerm ? new SalaryReviewTerm(data?.salaryReviewTerm) : null;
    this.user = data?.user ? new User(data?.user) : null;
    this.job = data?.job ? new Job(data?.job) : null;
    this.currentGradationalSalary = data?.currentGradationalSalary ? new GradationalSalary(data?.currentGradationalSalary) : null;
    this.gradationalSalary = data?.gradationalSalary ? new GradationalSalary(data?.gradationalSalary) : null;

    this.salaryReviewAllowances = data?.salaryReviewAllowances?.map(s => new SalaryReviewAllowance(s));
  }
}
